var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-centerForm",
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: "",
                    model: _vm.searchForm,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入订单号", clearable: "" },
                        model: {
                          value: _vm.searchForm.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderNo", $$v)
                          },
                          expression: "searchForm.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "乘客姓名", prop: "passengerName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入乘客姓名", clearable: "" },
                        model: {
                          value: _vm.searchForm.passengerName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "passengerName", $$v)
                          },
                          expression: "searchForm.passengerName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择状态", clearable: "" },
                          model: {
                            value: _vm.searchForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "status", $$v)
                            },
                            expression: "searchForm.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "待审批", value: "pending" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已通过", value: "approved" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已拒绝", value: "rejected" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.searchForm.applyTimeRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "applyTimeRange", $$v)
                          },
                          expression: "searchForm.applyTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh-left" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.refresh },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "v-tableEncapsulation",
        {
          attrs: {
            loading: _vm.loadingBtn.tableLoading,
            columnData: _vm.columnData,
            tableSize: _vm.pagination.size,
            tableData: _vm.tableData,
            tableTotal: _vm.pagination.total,
            currentPage: _vm.pagination.current,
          },
          on: {
            currentPage: _vm.handleCurrentChange,
            sizeChange: _vm.handleSizeChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              slot: "status",
              label: "状态",
              align: "center",
              width: "100px",
            },
            slot: "status",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getStatusTagType(scope.row.status),
                          effect: "dark",
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.statusText) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              slot: "operate",
              label: "操作",
              align: "center",
              width: "150px",
              fixed: "right",
            },
            slot: "operate",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === "pending"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.approve(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 审批 ")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "改签审批",
            visible: _vm.approveDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approveDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "approveForm",
              attrs: {
                model: _vm.approveForm,
                rules: _vm.approveRules,
                "label-width": "100px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "订单号" } }, [
                _c("span", [_vm._v(_vm._s(_vm.approveForm.orderNo))]),
              ]),
              _c("el-form-item", { attrs: { label: "乘客姓名" } }, [
                _c("span", [_vm._v(_vm._s(_vm.approveForm.passengerName))]),
              ]),
              _c("el-form-item", { attrs: { label: "原航班" } }, [
                _c("span", [_vm._v(_vm._s(_vm.approveForm.originalFlight))]),
              ]),
              _c("el-form-item", { attrs: { label: "新航班" } }, [
                _c("span", [_vm._v(_vm._s(_vm.approveForm.newFlight))]),
              ]),
              _c("el-form-item", { attrs: { label: "改签费用" } }, [
                _c(
                  "span",
                  { staticStyle: { color: "#f56c6c", "font-weight": "bold" } },
                  [_vm._v("$" + _vm._s(_vm.approveForm.changeFee))]
                ),
              ]),
              _c("el-form-item", { attrs: { label: "改签原因" } }, [
                _c("span", [_vm._v(_vm._s(_vm.approveForm.changeReason))]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "审批结果", prop: "approveResult" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.approveForm.approveResult,
                        callback: function ($$v) {
                          _vm.$set(_vm.approveForm, "approveResult", $$v)
                        },
                        expression: "approveForm.approveResult",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "approved" } }, [
                        _vm._v("通过"),
                      ]),
                      _c("el-radio", { attrs: { label: "rejected" } }, [
                        _vm._v("拒绝"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审批备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入审批备注",
                    },
                    model: {
                      value: _vm.approveForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.approveForm, "remark", $$v)
                      },
                      expression: "approveForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.approveDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loadingBtn.approveLoading,
                  },
                  on: { click: _vm.submitApprove },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }